/**
 * Fiskal Cloud Admin Archiving Usage API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Revoke deletion requested for data retention for the given year of origin. Extend data instead.
 */
export interface RevokeDeletionBodyDTO { 
    /**
     * Year of origin of the archived data for which the deletion has been requested and should be revoked.
     */
    origin: number;
    /**
     * Specify data retention that expire in the given year.
     */
    expirationYear: number;
    /**
     * The end of the extended retention period. Must be *after* origin and current year. Exclusive.
     */
    extension: number;
}

export class ClsRevokeDeletionBodyDTO { 
    /**
     * Year of origin of the archived data for which the deletion has been requested and should be revoked.
     */
    origin: number = undefined;
    /**
     * Specify data retention that expire in the given year.
     */
    expirationYear: number = undefined;
    /**
     * The end of the extended retention period. Must be *after* origin and current year. Exclusive.
     */
    extension: number = undefined;
}

